export default __webpack_public_path__ + "static/media/standard icon.c3f94521.png";